<template>
  <b-container fluid>
    <loading :active.sync="isCalculando" :is-full-page="true"></loading>
    <b-row class="margin" align-h="center" no-gutters>
      <b-col cols="12" >
       
        


        <b-row>
          <b-col cols="12">
            <b-form-group label="Grupos de Beneficiarios:">
              <b-form-select type="text"  :options="catalogCobro.gruposSubsidios" value-field="nombre" text-field="nombre" v-model="grupoActual" @change="beneficiarios=[]"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col v-if="this.grupoActual!=null && this.grupoActual!=''">
              <b-button variant="success" @click="consultaGrupo"> Consultar <b-icon icon="search"/> </b-button>
          </b-col>
          <b-col v-if="this.grupoActual!=null && this.grupoActual!=''">
            <b-button block @click="isShowAgregarClave=true" variant="info">Agregar Beneficiario <b-icon icon="person-fill" /></b-button>
          </b-col>
        </b-row>
        <b-row class="mt-5" v-if="this.grupoActual!=null && this.grupoActual!=''">
          <b-col cols="12" v-if="beneficiarios.length > 0">
            <b-form-input type="text" v-model="filter" placeholder="Buscar"></b-form-input>
          </b-col>
          
          <b-col cols="12" class="mt-3" v-if="beneficiarios.length > 0">
            <b-table :items="beneficiarios" :fields="fields" :filter="filter" small striped>
              <template v-slot:cell(acciones)="row">
                  <b-icon style="cursor:pointer;" icon="trash-fill" @click="showEliminarClave(row.item.clave, row.item.idGrupo)"/>
                </template>
            </b-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!--------------------------------------------------------------------- MODALS -------------------------------------------------------------------->

   

    <b-modal title="Agregar beneficiario" v-model="isShowAgregarClave" size="sm" hide-footer header-bg-variant="dark" header-text-variant="light">
      <b-row>
        <b-col cols="12"><h6><b-icon icon="person-fill"/> Ingresa la clave de contribuyente</h6> </b-col>
        <b-col cols="12"><b-form-input class="input-serie" type="text" v-model.trim="claveNva"></b-form-input></b-col>
        <b-col cols="12" class="mt-2"> <b-button variant="info" @click="agregarClave">Agregar <b-icon icon="person-fill"/></b-button></b-col>
      </b-row>
    </b-modal>

    <b-modal title="Eliminar beneficiario" v-model="isShowEliminarClave" size="sm" hide-footer header-bg-variant="dark" header-text-variant="light">
      <b-row>
        <b-col cols="12"><h6><b-icon icon="person-fill"/> ¿Desea eliminar la clave {{claveEliminar}} del grupo de beneficiarios?</h6> </b-col>
        <b-col cols="12" class="mt-2"> <b-button variant="info" @click="eliminarClave">Si, Eliminar <b-icon icon="trash-fill"/></b-button></b-col>
      </b-row>
    </b-modal>

  </b-container>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState} from 'vuex';
import { server, getGetConfig, getPostConfig, handledError } from '@/axios-tools';
import axios from 'axios';
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  computed:{
    ...mapState({
      isCalculando: state => state.cobro.isCalculando,
      catalogCobro: state => state.cobro.catalogCobro,
      token: state => state.login.token,
    }),
   

  },
  data(){
    return{
      beneficiarios:[],
      fields:["clave", "acciones"],
      claveNva:"",
      grupoActual:null,
      isShowAgregarClave:false,
      isShowEliminarClave:false,
      claveEliminar:null,
      idGrupoClaveEliminar:null,
      filter:null

    }
  },
  components: {
    Loading
  },
  methods:{
    
    consultaGrupo(){
      if(  this.grupoActual!=null  && !this.isCalculando){
          this.$store.commit("updateMsgErrorLiquidacion", null);        
          this.$store.commit("updateIsCalculando", true);
          axios(
            getGetConfig(server.gruposubsidios, null, this.token, {grupo: this.grupoActual})
          )
          .then(res => {
            this.beneficiarios = res.data;
            this.$store.commit("updateIsCalculando", false);
          }).catch(err => {
            handledError(err, server.gruposubsidios, this.$router, this.$store);
            this.$store.commit("updateIsCalculando", false);
          });
      }
    },
    agregarClave(){
     if(  !this.isCalculando && this.claveNva!=null && this.claveNva!= '' && this.grupoActual!=null && this.grupoActual!=''){
          this.isShowAgregarClave = false;
          this.$store.commit("updateMsgErrorLiquidacion", null);        
          this.$store.commit("updateIsCalculando", true);
          axios(
            getPostConfig(server.agregasubsidio, null, this.token, {clave: this.claveNva, grupo:this.grupoActual})
          )
          .then(() => {
            this.$store.commit("updateIsCalculando", false);
            alert("La clave de contribuyente fue agregada.");
            this.claveNva = null;
            this.beneficiarios=[];
          }).catch(err => {
            handledError(err, server.agregasubsidio, this.$router, this.$store);
            this.$store.commit("updateIsCalculando", false);
          });
      }
    },
    showEliminarClave(clave, idGrupo){
      this.claveEliminar = clave;
      this.idGrupoClaveEliminar = idGrupo;
      this.isShowEliminarClave = true;
    },
    eliminarClave(){
     if(  !this.isCalculando){
          this.isShowEliminarClave = false;
          this.$store.commit("updateMsgErrorLiquidacion", null);        
          this.$store.commit("updateIsCalculando", true);
          axios(
            getPostConfig(server.quitasubsidio, null, this.token, {clave: this.claveEliminar, idGrupo:this.idGrupoClaveEliminar})
          )
          .then(() => {
            this.$store.commit("updateIsCalculando", false);
            alert("La clave de contribuyente fue eliminada.");
            this.beneficiarios = [];
          }).catch(err => {
            handledError(err, server.quitasubsidio, this.$router, this.$store);
            this.$store.commit("updateIsCalculando", false);
          });
      }
    },
    
  },
  validations:{
    
  }
}
</script>
<style>
.row-to-img-orden{
  margin-left:40px;
}
.button-reenviar{
  margin-top: 5px;
}
.dropdown{
  margin-bottom: 5px;
}
.input-folio{
  margin-top:10px;
}
.input-serie{
  margin-top:10px;
}
.b-icon-info-recibo{
  margin-right:20px;
}
.margin-radio-recibo{
  margin-right:5px;
}
.margin-radio-linea{
  margin-right:5px;
}
.link-pdf{
  margin-left:20px;
}
.margin{
  margin: 5px auto;
}
div.error{
  color: red;
}
div.success{
  color: green;
  margin-bottom: 10px;
}

/*------------------------------------------------------------------------------- THEMS -------------------------------------------------------------------------- */
.teotihuacan:hover{
   background-color:#A03455;
   border-color:#A03455;
}
.teotihuacan{
   background-color:#9D2449; 
   border-color:#9D2449;
}
.demo:hover{
  background-color:#5F58B1;
   border-color:#5F58B1;
}
.demo{
  background-color:#312991; 
   border-color:#312991;
}
</style>